export const createScriptElement = (content, src = null) => {
  const script = document.createElement("script");
  if (src) {
    script.src = src;
    script.async = true;
  } else {
    script.innerText = content;
  }
  document.body.appendChild(script);
};

export const initializeCashkoro = () => {
  // Cashkoro Script
  const setAffiliateClick = (value) => {
    const dateAf = new Date();
    dateAf.setTime(dateAf.getTime() + 1 * 24 * 60 * 60 * 1000); // 1 day expiry
    document.cookie = `affclick=${value};expires=${dateAf.toUTCString()};path=/`;
    window.localStorage.setItem("affclick", value);
  };

  const clickId = new URLSearchParams(window.location.search).get("clickid");
  if (clickId) setAffiliateClick(clickId);
};

export const addNewScriptCashKoroThankYouPage = (orderDetails) => {
  const scriptContent = `
      var afoffer_id = 698;
      var afid='${orderDetails?.shopifyId || ""}';
      var afprice='${orderDetails?.finalAmount || ""}';
      var afgoal=1;
      var custom_field1='${orderDetails?.finalAmount || ""}';
      var custom_field2='${orderDetails?.cart?.discountCode || ""}';
      var custom_field3='${orderDetails?.discount || ""}';
      var custom_field4='${orderDetails?.paymentGateway || ""}';
      var afstatus=2;
      var afsecure = "44acb40ef5d1764a4e4eb55b2373e832";
    `;

  createScriptElement(scriptContent);
  createScriptElement(null, "https://secure.traqkarr.com/track.js");
};
